import header from "./wohnflaechenverordnung.webp";
import section1 from "./creative-women-working-about-new-project-house.jpg";
import section2 from "./rolls-blueprint.jpg";
import section3 from "./heating-system.jpg";
import section4 from "./working-from-home-time-management-concept.jpg";
import section5 from "./wohnraumfoerderungsgesetz.webp";
import section6 from "./engineer-working-project.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
